import { format as dateFnsFormat } from 'date-fns';
import type { Composer } from 'vue-i18n';

export interface I18nDFormatOptions {
  localLowerCase?: boolean;
}

export function useEkI18n() {
  let i18n: Composer;

  // useI18n is dependent on the currentInstance and will throw an error if it is not available
  // This is sometimes the case when used inside of a pinia store
  // So when thats the case we get the global i18n instance from the nuxt app
  if (getCurrentInstance() !== null) {
    i18n = useI18n();
  } else {
    // taken from here: https://github.com/intlify/vue-i18n-next/issues/904#issuecomment-1565682148
    i18n = useNuxtApp().$i18n;
  }

  function d(inputDate: Date|string|number, localeFormat: string, options: I18nDFormatOptions = {}) {
    const {
      localLowerCase = false
    } = options;

    if (!inputDate) {
      return '';
    }

    const date = new Date(inputDate);

    const format = i18n.t(localeFormat);

    try {
      let formattedDate = dateFnsFormat(date, format);

      if (localLowerCase) {
        formattedDate = formattedDate.toLocaleLowerCase();
      }

      return formattedDate;
    } catch {
      return inputDate.toString();
    }
  }

  return { ...i18n, d };
}
